import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import Icon from '../Icon/icon';

export const ButtonChipStyled = styled.button`
${({ theme }) => {
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
    let chipWidth = '100%';
    let padding = `${rem(10)} ${rem(40)}`;

    if (mediumUp) {
      chipWidth = 'auto';
      padding = `${rem(10)} ${rem(20)}`;
    }

    return css`
      position: relative;
      display: flex;
      align-items: center;
      justify-content:center;
      width: ${chipWidth};
      background-color: transparent;
      border: 1px solid ${theme.colors.primary.blue};
      border-radius: ${rem(30)};
      color: ${theme.colors.primary.blue};
      padding: ${padding};
      :hover,
      :focus {
        cursor: pointer;
        border-color: ${theme.colors.cta.blue};
        color: ${theme.colors.cta.blue};
      }
      :active {
        background-color: ${theme.colors.primary.blue};
        cursor: pointer;
        border-color: ${theme.colors.neutral.white};
        color: ${theme.colors.neutral.white};
      }
  `;
  }
}`;

export const IconChipAdornmentStyled = styled(Icon)`
${({ text, theme }) => {
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
    let position = 'absolute';
    let left = rem(15);

    if (mediumUp) {
      position = 'relative';
      left = 0;
    }

    return css`
      position: ${position};
      max-height: ${rem(25)};
      margin-right: ${text ? rem(10) : 0};
      left: ${left};
      :hover,
      :focus {
        fill: ${theme.colors.cta.blue};
      }
      :active {
        fill: ${theme.colors.neutral.white};
      }
    `;
  }
}`;
